module.exports = __webpack_public_path__ + "img/image_user_avatar.797084c5.png";